import { Card, CardBody } from "@/components/ui";
import { SiteFrame } from "@/site/SiteFrame";

import type { Block, LegalDoc } from "./docs";

function BlockView({ block }: { block: Block }) {
  if (typeof block === "string") return <p>{block}</p>;
  return (
    <ul className="list-disc space-y-1.5 pl-5">
      {block.list.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

/** A policy page: title, date and numbered sections, readable on a phone. */
export function LegalPage({ doc }: { doc: LegalDoc }) {
  return (
    <SiteFrame>
      <article className="mx-auto max-w-3xl py-4 sm:py-8">
        <header className="mb-6">
          <h1 className="font-display text-3xl font-bold sm:text-4xl">{doc.title}</h1>
          <p className="mt-2 text-sm text-muted">{doc.summary}</p>
          <p className="mt-1 text-xs text-subtle">Last updated {doc.updated}</p>
        </header>
        <Card>
          <CardBody className="space-y-8 p-5 sm:p-8">
            {doc.sections.map((s) => (
              <section key={s.heading} className="space-y-3">
                <h2 className="font-display text-lg font-bold text-fg">{s.heading}</h2>
                <div className="space-y-3 text-sm leading-relaxed break-words text-muted">
                  {s.body.map((b, i) => (
                    <BlockView key={i} block={b} />
                  ))}
                </div>
              </section>
            ))}
          </CardBody>
        </Card>
      </article>
    </SiteFrame>
  );
}
